import React, { useContext, useEffect, useState } from "react";
import { TemplateContext } from "../../layout";
import { ProductPackageItem } from "./ProductPackageItem";
import PackageBundleItem from "./PackageBundleItem";
const productsHeading = window.post_template?.checkout_v4_products?.tr_checkout_v4_products_heading;

const ProductPackages = () => {
  const [templateContext, setTemplateContext] = useContext(TemplateContext);
  const [index, setIndex] = useState(window.products.findIndex((element) => element.best_seller === true));
  const [initialLoad, setIntialLoad] = useState(true);
  const bundles = window.productData?.show_bundle_design;
  const products = window.products;

  useEffect(() => {
    const element = document.getElementById(`productCard-${index}`);
    if (!element || initialLoad) return;
    setTimeout(() => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio < 1) {
              element.scrollIntoView({ behavior: "smooth", block: "start" });
            }
          });
        },
        {
          threshold: [0, 1],
        }
      );
      observer.observe(element);
      setTimeout(() => {
        return observer.disconnect();
      }, 310);
    }, 300);
  }, [index]);

  return (
    <>
      <div data-testid="products-label" className="productPackages__heading" id="products">
        {productsHeading}
      </div>
      <div className="productPackages__wrapper">
        {products &&
          products.map((product, i) => {
            const handleChange = (index) => {
              setTemplateContext({
                ...templateContext,
                config: { ...templateContext.config, product: products[index] },
              });
              if (initialLoad) {
                setIntialLoad(false);
              }
              setIndex(i);
            };
            if (bundles) {
              return (
                <PackageBundleItem
                  key={i}
                  product={product}
                  handleChange={() => {
                    handleChange(i);
                  }}
                  active={i === index}
                  index={i}
                />
              );
            } else {
              return (
                <ProductPackageItem
                  key={i}
                  product={product}
                  handleChange={() => {
                    handleChange(i);
                  }}
                  active={i === index}
                  index={i}
                />
              );
            }
          })}
      </div>
    </>
  );
};

export default ProductPackages;
